type ColorDotProps = {
  color: string;
  title?: string;
};

export function ColorDot({ color, title }: ColorDotProps) {
  return (
    <span
      className="w-5 h-5 rounded-full"
      style={{ backgroundColor: color }}
      title={title}
    />
  );
}

export function MiddleCircle({ children }: { children: React.ReactNode }) {
  return (
    <span className="flex items-center justify-center w-6 h-6 rounded-full bg-white">
      {children}
    </span>
  );
}

export function OuterCircle({ children }: { children: React.ReactNode }) {
  return (
    <span className="inline-flex items-center justify-center w-7 h-7 p-0.5 rounded-full hover:bg-neutrals-N300 transition-colors duration-200">
      {children}
    </span>
  );
}

export default function ColoredDot({ color, title }: ColorDotProps) {
  return (
    <OuterCircle>
      <MiddleCircle>
        <ColorDot color={color} title={title} />
      </MiddleCircle>
    </OuterCircle>
  );
}
